import React, { useEffect, useRef, useState } from "react";
import { getExecutionCostAPI } from "../../service/ai.service";

const TimelineTable = () => {
    const weeks = useRef(Array.from({ length: 24 }, (_, i) => i + 1));
    const [executionCost, setExecutionCost] = useState([]);
    useEffect(() => {
        getExecutionCostAPI().then(response => {
            setExecutionCost(response);
        }).catch(error => {
            console.error("Error fetching execution cost data:", error);
        });
    }, [])

    const render = () => {
        return (
            <div className="table-container-maturity">
                <table>
                    <tr>
                        <th className="nobordernobg"></th>
                        <th>Problem/ Pain</th>
                        <th>Solution</th>
                        <th>Solution</th>
                        <th>Cost</th>
                        {weeks.current.map(i => <th>{i}</th>)}
                    </tr>
                    <tbody>
                        <tr>
                            <td className="nobordernobg" rowspan="3">
                                <div className="tlevel1">
                                    <div>Level 1</div>
                                    <div>Awarness</div>
                                </div>
                            </td>
                            <td rowspan="3" className="category">How does it fit with current strategy?</td>
                            <td rowspan="3" className="sub-category">AI Consulting</td>
                            <td>AI Strategy</td>
                            <td>{executionCost.ai_strategy}</td>
                            {weeks.current.map(i => <td className={`${i <= 4 ? 'green' : ''} ${i === 4 ? 'dark-green' : ''}`} />)}
                        </tr>
                        <tr>
                            <td>AI Value</td>
                            <td>{executionCost.ai_value}</td>
                            {weeks.current.map(i => <td className={`${4 <= i && i <= 6 ? 'green' : ''} ${i === 6 ? 'dark-green' : ''}`} />)}
                        </tr>
                        <tr>
                            <td>AI Roadmap</td>
                            <td>{executionCost.ai_roadmap}</td>
                            {weeks.current.map(i => <td className={`${5 <= i && i <= 8 ? 'green' : ''} ${i === 8 ? 'dark-green' : ''}`} />)}
                        </tr>
                        <tr>
                            <td className="nobordernobg" rowspan="3">
                                <div className="tlevel2">
                                    <div>Level 2</div>
                                    <div>Active</div>
                                </div>
                            </td>
                            <td rowspan="3" className="category">Resource constraint</td>
                            <td rowspan="3" className="sub-category">“Full Serve” AI Transformation<br />360Business.AI</td>
                            <td>Company Workflow</td>
                            <td>{executionCost.company_workflow}</td>
                            {weeks.current.map(i => <td className={`${i <= 4 ? 'green' : ''} ${i === 4 ? 'dark-green' : ''}`} />)}
                        </tr>
                        <tr>
                            <td>Partner Workflow</td>
                            <td>{executionCost.partner_workflow}</td>
                            {weeks.current.map(i => <td className={`${4 <= i && i <= 8 ? 'green' : ''} ${i === 8 ? 'dark-green' : ''}`} />)}
                        </tr>
                        <tr>
                            <td>Custom Workflow</td>
                            <td>{executionCost.custom_workflow}</td>
                            {weeks.current.map(i => <td className={`${9 <= i && i <= 12 ? 'green' : ''} ${i === 12 ? 'dark-green' : ''}`} />)}
                        </tr>
                        <tr>
                            <td className="nobordernobg" rowspan="6">
                                <div className="tlevel3">
                                    <div>Level 3</div>
                                    <div>Operational</div>
                                </div>
                                <div className="levelmid-title">AI maturity</div>
                            </td>
                            <td rowspan="3" className="category">AI is mysterious</td>
                            <td rowspan="3" className="sub-category">AI Training</td>
                            <td>AI Intro</td>
                            <td>{executionCost.ai_intro}</td>
                            {weeks.current.map(i => <td className={`${i <= 4 ? 'green' : ''} ${i === 4 ? 'dark-green' : ''}`} />)}
                        </tr>
                        <tr>
                            <td>AI Delivery</td>
                            <td>{executionCost.ai_delivery}</td>
                            {weeks.current.map(i => <td className={`${5 <= i && i <= 8 ? 'green' : ''} ${i === 8 ? 'dark-green' : ''}`} />)}
                        </tr>

                        <tr>
                            <td>AI Ultimate</td>
                            <td>{executionCost.ai_ultimate}</td>
                            {weeks.current.map(i => <td className={`${5 <= i && i <= 12 ? 'green' : ''} ${i === 12 || i === 8 ? 'dark-green' : ''}`} />)}
                        </tr>
                        <tr>
                            <td rowspan="3" className="category">Change is hard</td>
                            <td rowspan="3" className="sub-category">AI Change Management</td>
                            <td>Leadership Strategy</td>
                            <td>{executionCost.leadership_strategy}</td>
                            {weeks.current.map(i => <td className={`${13 <= i && i <= 16 ? 'green' : ''} ${i === 16 ? 'dark-green' : ''}`} />)}
                        </tr>
                        <tr>
                            <td>Process Redesign</td>
                            <td>{executionCost.process_redesign}</td>
                            {weeks.current.map(i => <td className={`${15 <= i && i <= 20 ? 'green' : ''} ${i === 20 ? 'dark-green' : ''}`} />)}
                        </tr>
                        <tr>
                            <td>Cultural Adoption</td>
                            <td>{executionCost.cultural_adoption}</td>
                            {weeks.current.map(i => <td className={`${19 <= i && i <= 24 ? 'green' : ''} ${i === 24 ? 'dark-green' : ''}`} />)}
                        </tr>
                        <tr>
                            <td className="nobordernobg" rowspan="4">
                                <div className="tlevel4">
                                    <div>Level 4</div>
                                    <div>Systemic</div>
                                </div>
                            </td>
                            <td rowspan="4" className="category">How to move up the AI ladder - Take Control</td>
                            <td rowspan="4" className="sub-category">“Self Serve” AI Transformation</td>
                            <td>Custom Workflow 1</td>
                            <td>{executionCost.custom_workflow_1}</td>
                            {weeks.current.map(i => <td className={`${13 <= i && i <= 16 ? 'green' : ''} ${i === 16 ? 'dark-green' : ''}`} />)}
                        </tr>
                        <tr>
                            <td>Custom Workflow 2</td>
                            <td>{executionCost.custom_workflow_2}</td>
                            {weeks.current.map(i => <td className={`${17 <= i && i <= 20 ? 'green' : ''} ${i === 20 ? 'dark-green' : ''}`} />)}
                        </tr>
                        <tr>
                            <td>Custom Workflow 3</td>
                            <td>{executionCost.custom_workflow_3}</td>
                            {weeks.current.map(i => <td className={`${21 <= i && i <= 24 ? 'green' : ''} ${i === 24 ? 'dark-green' : ''}`} />)}
                        </tr>
                        <tr>
                            <td>Life Cycle Mgt</td>
                            <td>{executionCost.life_cycle_mgt}</td>
                            {weeks.current.map(i => <td className={`${13 <= i && i <= 24 ? 'green' : ''} ${i === 24 ? 'dark-green' : ''}`} />)}
                        </tr>
                        <tr>
                            <td className="nobordernobg" rowspan="2">
                                <div className="tlevel5">
                                    <div>Level 5</div>
                                    <div>Trasfomational</div>
                                </div>
                            </td>
                            <td rowspan="2" className="category">How to maintain models and Apps</td>
                            <td rowspan="2" className="sub-category">AI Ops</td>
                            <td>Retraining</td>
                            <td>{executionCost.retraining}</td>
                            {weeks.current.map(i => <td className={`${13 <= i && i <= 24 ? 'green' : ''} ${i === 24 ? 'dark-green' : ''}`} />)}
                        </tr>
                        <tr>
                            <td>Updates</td>
                            <td>{executionCost.updates}</td>
                            {weeks.current.map(i => <td className={`${13 <= i && i <= 24 ? 'green' : ''} ${i === 24 ? 'dark-green' : ''}`} />)}
                        </tr>
                    </tbody>
                </table>
            </div >
        )
    }
    return render();
}

export default TimelineTable